/* global window */

interface ImmutableDebugPerformance {
    /** The number of times the hash function was called */
    hashCollectionsCount: number;
    /** The number of times the hash function was called */
    hashCollectionsCachedCount: number;
    /** The number of calls to freeze a collection */
    freezeCollectionsCount: number;
    /** The number of calls to freeze a collection that have been cached */
    freezeCollectionsCachedCount: number;
    /** The number of collisions detected */
    hashCollisionsCount: number;
    /** Total time spent hashing */
    hashTime: number;
    /** The number of primitives hash allocated */
    hashValuesTotalCount: number;
    /** The number of primitives hash still allocated */
    hashValuesCount: number;
    /** The number of memoized calls */
    memoizeCount: number;
    /** The number of memoized calls that are memoized */
    memoizeCachedCount: number;
    /**
     * the number of memoized calls per function.
     */
    memoizeFunctions: {
        [key: string]: {
            count: number;
            cachedCount: number;
            totalTime: number;
            totalCachedTime: number;
        };
    };
}

// @ts-ignore - util-immutable can run in a TS codebase without lib: dom
const HAS_PERF = typeof performance !== 'undefined';

export function perfNow() {
    // @ts-ignore
    if (!globalThis.PERF_ENABLED || !HAS_PERF) {
        return 0;
    }
    return performance.now();
}
export const debugPerformance: ImmutableDebugPerformance = {
    hashCollectionsCount: 0,
    hashCollectionsCachedCount: 0,
    freezeCollectionsCount: 0,
    freezeCollectionsCachedCount: 0,
    hashCollisionsCount: 0,
    hashTime: 0,
    hashValuesTotalCount: 0,
    hashValuesCount: 0,
    memoizeCount: 0,
    memoizeCachedCount: 0,
    memoizeFunctions: {},
};

export function logImmutableDebugPerformance() {
    // biome-ignore lint/suspicious/noConsole: We need to log to the console here
    console.table([
        ['# of collections hashed', debugPerformance.hashCollectionsCount],
        ['# of collections hashed cached', debugPerformance.hashCollectionsCachedCount],
        ['# of collections frozen', debugPerformance.freezeCollectionsCount],
        ['# of collections frozen cached', debugPerformance.freezeCollectionsCachedCount],
        ['# of collisions with collections', debugPerformance.hashCollisionsCount],
        ['Total time spent hashing', debugPerformance.hashTime],
        [
            'Average time spent hashing (ms)',
            debugPerformance.hashTime / debugPerformance.hashCollectionsCount,
        ],
        ['# of JS values hashed', debugPerformance.hashValuesTotalCount],
        ['# of JS values hashed still allocated', debugPerformance.hashValuesCount],
        ['# of memoized calls', debugPerformance.memoizeCount],
        ['# of memoized calls that are memoized', debugPerformance.memoizeCachedCount],
    ]);
    // biome-ignore lint/suspicious/noConsole: We need to log to the console here
    console.table([
        [
            '% ratio of hash caching',
            `${(
                (debugPerformance.hashCollectionsCachedCount * 100) /
                    debugPerformance.hashCollectionsCount
            ).toFixed(2)}%`,
        ],
        [
            '% ratio of memoization',
            `${(
                (debugPerformance.memoizeCachedCount * 100) / debugPerformance.memoizeCount
            ).toFixed(2)}%`,
        ],
    ]);
    // biome-ignore lint/suspicious/noConsole: We need to log to the console here
    console.table(
        Object.entries(debugPerformance.memoizeFunctions)
            .filter(([, item]) => item.count > 0)
            .sort(([, a], [, b]) => b.count - a.count)
            .map(([key, value]) => {
                const averageExecutionTime = value.totalTime / value.count;
                const averageCachedExecutionTime = value.totalCachedTime / value.cachedCount;

                return {
                    function: key,
                    '# of calls': value.count,
                    '# of calls that are memoized': value.cachedCount,
                    'Total time spent (ms)': value.totalTime,
                    'Average time spent (ms)': averageExecutionTime,
                    'Worth it?': `${
                        averageExecutionTime > averageCachedExecutionTime ? '👌' : '❌'
                    } ${(
                        (100 * (averageExecutionTime - averageCachedExecutionTime)) /
                            averageExecutionTime
                    ).toFixed(2)}%`,
                };
            })
    );
}

// @ts-ignore - util-immutable can run in a TS codebase without lib: dom
if (typeof window !== 'undefined') {
    // @ts-ignore - util-immutable can run in a TS codebase without lib: dom
    window.logImmutableDebugPerformance = logImmutableDebugPerformance;
}
